App = App || {};

App.ProfileEditor = (function ($, Vue) {
	"use strict";

	function init(target) {
		target = target || document.getElementById("profile-app");

		if (!target || target.dataset.mounted)
			return;

		target.dataset.mounted = "1";

		new Vue({
			el: target,
			data: {
				form: {
					id: target.dataset.id,
					firstName: '',
					middleInitial: '',
					lastName: '',
					street: '',
					city: '',
					postalCode: '',
					email: '',
					phone: '',
					phoneExt: '',
					securityQuestion: '',
					securityAnswer: '',
					prostaffPrograms: '',
					opticsUser: '',
					agreedToTerms: false,
					recaptchaToken: '',
					hobbies: [],
					timeInRetail: '',
					country: "USA",
					region: "",
					dealer: null,
					useCustomDealer: false,
					customDealer: {
						name: "",
						address: ""
					}
				},
				countries: [],
				dealers: [],
				isSubmitting: false,
				isChanging: false,
				isComplete: false,
				alertMessage: "",
				alertErrors: []
			},
			computed: {
				currentCountry: function () {
					return this.countries.find(c => c.code === this.form.country);
				},
				currentRegions: function () {
					return this.currentCountry?.regions || [];
				},
				storeAddress: function () {
					return [this.form.dealer?.street, this.form.dealer?.city, this.form.dealer?.region]
						.filter(Boolean)
						.join(", ");
				}
			},
			methods: {
				onCountryChange: function () {
					const selectedCountry = this.countries.find(c => c.code === this.form.country);
					this.form.region = (selectedCountry?.regions?.[0]?.code) || "";
				},
				formatDealerLabel: function (dealer) {
					if (!dealer)
						return "";

					return `${dealer.name} (${dealer.city}, ${dealer.state})`;
				},
				loadCountries: function () {
					$.ajax({
						url: "/api/countries",
						method: "GET",
						dataType: "json"
					})
						.done(response => {
							if (response.success) {
								this.countries = response.data;
								if (!this.form.region)
									this.onCountryChange();
							}
						})
						.fail((jqXHR, status, err) => {
							console.error("AJAX error loading countries:", status, err);
						});
				},

				loadDealers: function () {
					$.ajax({
						url: "/api/dealers/all",
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response.success) {
							this.dealers = response.data;
							const id = this.form.dealer?.id ?? null;
							this.form.dealer = this.dealers.find(d => d.id === id) || null;
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading dealers:", status, err);
					});
				},

				scrollToFormTop() {
					this.$nextTick(() => {
						const topOffset = this.$el.getBoundingClientRect().top + window.pageYOffset - 20;
						window.scrollTo({ top: topOffset, behavior: 'smooth' });
						this.$refs.topAlert?.focus?.({ preventScroll: true });
					});
				},

				saveProfile: function () {
					var form = this.$refs.form;
					if (!form.checkValidity()) {
						form.classList.add("was-validated");
						return;
					}

					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];
					this.isComplete = false;

					$.ajax({
						url: "/api/members/",
						method: "PUT",
						contentType: "application/json",
						data: JSON.stringify(this.form)
					})
						.done(resp => {
							if (resp && resp.success) {
								this.isComplete = true;
								this.scrollToFormTop();
							} else {
								this.alertMessage = (resp && resp.message) || "Save failed.";
								this.alertErrors = (resp && resp.data && resp.data.errors || []).map(e => e.description).filter(Boolean);
								form.classList.add("was-validated");
								this.scrollToFormTop();
							}
						})
						.fail(() => {
							this.alertMessage = "Save failed.";
							form.classList.add("was-validated");
							this.scrollToFormTop();
						})
						.always(() => {
							this.isSubmitting = false;
						});
				}, 

				loadProfile: function () {
					return $.ajax({
						url: `/api/members/${this.form.id}`,
						method: "GET",
						dataType: "json"
					})
						.done(response => {
							if (!response || !response.success || !response.data) {
								this.alertMessage = (response && response.message) || "Failed loading profile.";
								return;
							}

							const profile = response.data;
							this.form.firstName = profile.firstName ?? "";
							this.form.middleInitial = profile.middleInitial ?? "";
							this.form.lastName = profile.lastName ?? "";
							this.form.street = profile.street ?? "";
							this.form.city = profile.city ?? "";
							this.form.postalCode = profile.postalCode ?? "";
							this.form.country = profile.country ?? "USA";
							this.form.region = profile.region ?? "";
							this.form.email = profile.email ?? "";
							this.form.phone = profile.phone ?? "";
							this.form.phoneExt = profile.phoneExt ?? "";
							this.form.securityQuestion = profile.securityQuestion ?? "";
							this.form.securityAnswer = profile.securityAnswer ?? "";
							this.form.prostaffPrograms = profile.prostaffPrograms ?? "";
							this.form.opticsUser = profile.opticsUser ?? "";
							this.form.agreedToTerms = profile.agreedToTerms ?? false;
							this.form.recaptchaToken = profile.recaptchaToken ?? "";
							this.form.hobbies = Array.isArray(profile.hobbies) ? profile.hobbies : (profile.hobbies ? [profile.hobbies] : []);
							this.form.timeInRetail = profile.timeInRetail ?? "";
							this.form.dealer = profile.dealer ?? null;
							this.form.useCustomDealer = profile.useCustomDealer ?? false;

							const customDealerApi = profile.customDealer || {};
							this.form.customDealer = {
								name: customDealerApi.name ?? "",
								address: customDealerApi.address ?? ""
							};
						})
						.fail((jqXHR, status, err) => {
							console.error("AJAX error loading profile:", status, err);
							this.alertMessage = "Failed loading profile.";
						});
				}
			},
			mounted: function () {
				this.loadProfile()
					.always(() => {
						this.loadCountries();
						this.loadDealers();
					});
			}
		});
	}

	return { init: init };
})(jQuery, Vue);


App.ProfileEditor.init();
